/* eslint-disable no-console, no-undef */
import Glide from '../vendors/glide.min';

window.RESET_GLIDE_EVENT = 'reset-glide';
window.resetGlideEvent = new Event(window.RESET_GLIDE_EVENT);

const gridSliders = () => {
  if (document.querySelectorAll('.grid-slider').length === 0) {
    return;
  }
  const sliders = [];
  const breakpoints = {
    10000: {
      perView: 4,
      focusAt: 0,
      minWidth: 992,
    },
    991: {
      perView: 3,
      focusAt: 0,
      minWidth: 768,
    },
    767: {
      perView: 3,
      focusAt: 0,
      minWidth: 625,
    },
    624: {
      perView: 2,
      focusAt: 0,
      minWidth: 450,
    },
    449: {
      perView: 1,
      focusAt: 0,
      minWidth: 0,
    },
  };

  const getMinItemsForScreenWidth = () => {
    const { innerWidth } = window;
    let ct = 0;
    Object.keys(breakpoints).forEach((key) => {
      if (breakpoints[key].minWidth <= innerWidth) {
        ct = breakpoints[key].perView;
      }
    });
    return ct;
  };

  const init = (slider) => {
    slider.glideRef = new Glide(slider.element, {
      autoplay: false,
      breakpoints,
      gap: 0,
      perView: 4,
      startAt: 0,
      type: 'carousel',
    });
    slider.glideRef.mount();
  };

  const updateGlideEvents = () => {
    sliders.forEach((slider) => {
      const { element, length } = slider;
      // Need to check what max length should be at any given breakpoint
      // console.log(`${length}/${getMinItemsForScreenWidth()}`);
      if (length > getMinItemsForScreenWidth() && !slider.enabled) {
        slider.enabled = true;
        init(slider);
        // Show navigation arrows
        element.querySelector('.gallery-grid-arrows').classList.remove('hidden');
      }
      if (length <= getMinItemsForScreenWidth() && slider.enabled) {
        // console.log('destroy');
        slider.enabled = false;
        slider.glideRef.destroy();
        slider.glideRef = null;
        // Hide navigation arrows
        element.querySelector('.gallery-grid-arrows').classList.add('hidden');
      }
      if (slider.glideRef) {
        slider.glideRef.update({ startAt: 0 });
      }
    });
    // console.log(sliders);
  };

  window.addEventListener('resize', () => {
    updateGlideEvents();
  });

  window.addEventListener(window.RESET_GLIDE_EVENT, () => {
    updateGlideEvents();
  });

  [].map.call(document.querySelectorAll('.grid-slider'), (slider) => {
    sliders.push({
      element: slider,
      enabled: false,
      glideRef: null,
      length: slider.querySelectorAll('.grid-slider-item').length,
    });
  });
  updateGlideEvents();
};

export default gridSliders;
/* eslint-enable no-console, no-undef */
